<section class="section section--maximise-rewards pdf-page-wrapper">
  <div class="container container--maximise-rewards">
    <h2 class="secondary-heading" [innerText]="'Maximise your reward.' | translate"></h2>
    <h3 class="tertiary-heading" [innerText]="'Make the most of everything we offer.' | translate"></h3>

    <div class="row row-maximise-rewards-print">
      @for (reward of maximiseRewards.slice(0, 4); track trackByFn(i, reward); let i = $index) {
        <div
          class="col-sm-12 col-xl-6 maximise-rewards-print-layout">
          <div class="maximise-reward-tile">
            <div class="maximise-reward-tile__icon-bg maximise-reward-tile__icon-bg--{{i + 1}}">
              <img class="maximise-reward-tile__icon"
                [src]="'https://storage.googleapis.com/archipelago-assets/total-impact-statement/icons/' + reward.icon"
                [alt]="reward.title">
            </div>
            <div class="maximise-reward-tile__cta">
              <h4 class="quaternary-heading quaternary-heading--maximise-rewards print-only__secondary-heading"
              [innerText]="reward.title"></h4>
              <p class="maximise-reward-tile__description" [innerText]="reward.description"></p>
              @if (reward.link) {
                <div class="maximise-reward-tile__link">
                  <a [href]="reward.link" class="btn btn-primary mb-0"
                  [attr.aria-label]="'Learn more about ' + reward.title" [innerText]="'Learn more' | translate"></a>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>

  </div>
</section>

<!--Blank page added after Maximise Reward and before back cover when odd number of pages present-->
@if (isBlankPageNeededForPdf) {
  <section class="section--pdf-blank pdf-page-wrapper"></section>
}
